import React from "react";

const LoadingSpinner = () => {
  return (
    <div className="flex items-center justify-center h-screen w-full bg-white/90 fixed inset-0 z-50 animate-fade-in">
      <div className="relative">
        <div className="w-16 h-16 rounded-full border-4 border-t-primary border-r-primary-light border-b-primary-lightest border-l-transparent animate-spin shadow-glow"></div>

        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-4 h-4 bg-primary-light rounded-full animate-pulse"></div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
